module.exports = __webpack_public_path__ + "static/media/loading.c2b11286.svg";